import { ProgramProgress, ProgramProgressSchema } from '@xq/domain';

export type FBProgramProgress = ProgramProgress;

export class ProgramProgressMapper {
  static toDomain(programProgress: FBProgramProgress): ProgramProgress {
    return ProgramProgressSchema.parse(programProgress);
  }
}
